import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Checkbox,
  DownloadFile,
  Tag,
  Menu,
  Dropdown,
} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import {
  DownloadOutlined,
  UndoOutlined,
  DownOutlined,
  FilterFilled,
} from "@ant-design/icons";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import apiPath from "../constants/apiPath";
import lang from "../helper/lang";
import moment from "moment";
const { TextArea } = Input;
const Search = Input.Search;
const { Option } = Select;

const baseUrl = "/admin/transaction";

function Transaction() {
  const { request } = useRequest();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selected, setSelected] = useState();
  const [filter, setFilter] = useState({});
  const [userType, setUserType] = useState(null);
  const [status, setStatus] = useState(null);
  const [excelLoading, setExcelloading] = useState(false);

  const { RangePicker } = DatePicker;
  const roleMap = {
    CP: "Certified Practitioner",
    MF: "Master Facilitator",
    Admin: "Admin",
  };
  const columns = [
    {
      title: lang("Transaction ID"),
      dataIndex: "transactionId",
      key: "transactionId",
      render: (val) => val || "-",
    },
    {
      title: lang("User Name"),
      dataIndex: "payee",
      key: "userName",
      render: (payee) => payee?.name || "-",
    },
    // {
    //   title: lang("User"),
    //   dataIndex: "user",
    //   key: "user",
    //   render: (val) => val || "-",
    // },
    {
      title: lang("User Role"),
      dataIndex: "user_role",
      key: "user_role",
      render: (val) => {
        const roleDisplayMap = {
          certified_practitioner: "Certified Practitioner",
          master_facilitator: "Master Facilitator",
          admin: "Admin",
        };
        return roleDisplayMap[val] || val || "-";
      },
    },
    // {
    //   title: lang("Transaction Amount"),
    //   dataIndex: "amount",
    //   key: "amount",
    //   render: (val, record) => `${record.currency || 'USD'} ${val || 0}`,
    // },

    {
      title: lang("Credits Details"),
      dataIndex: "creditType",
      key: "creditType",
      render: (val, record) => {
        const { credits_purchased } = record;
        let details = val || "";
        if (credits_purchased && credits_purchased.length > 0) {
          const purchasedDetails = credits_purchased
            .map(
              (credit, index) =>
                `${credit.type}: ${credit.quantity} x $${credit.unit_price}`
            )
            .join("\n");
          details += "\n" + purchasedDetails;
        }
        return <div>{details}</div>;
      },
    },

    // {
    //   title: lang("Credits Purchased"),
    //   key: "credits_purchased",
    //   render: (_, record) => {
    //     const { credits_purchased } = record;
    //     if (credits_purchased && credits_purchased.length > 0) {
    //       return credits_purchased.map((credit, index) => (
    //         <div key={index}>
    //           {credit.type}: {credit.quantity} x ${credit.unit_price}
    //         </div>
    //       ));
    //     }
    //     return "-";
    //   },
    // },
    {
      title: lang("Credits Spent"),
      dataIndex: "creditsSpent",
      key: "creditsSpent",
      render: (val) => val || 0,
    },
    // {
    //   title: lang("Credit Type"),
    //   dataIndex: "creditType",
    //   key: "creditType",
    //   render: (val) => val || "-",
    // },
    // {
    //   title: lang("Balance After"),
    //   dataIndex: "balanceAfter",
    //   key: "balanceAfter",
    //   render: (val) => val || 0,
    // },
    {
      title: lang("Transaction Type"),
      dataIndex: "type",
      key: "type",
      render: (val) => val?.replace("_", " ").toUpperCase() || "-",
    },
    {
      title: lang("Payment Status"),
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (status) => {
        const colorMap = {
          pending: "orange",
          approved: "green",
          rejected: "red",
        };
        return (
          <Tag color={colorMap[status] || "default"} style={{cursor:"default"}}>
            {status?.charAt(0).toUpperCase() + status?.slice(1)}
          </Tag>
        );
      },
    },
    {
      title: lang("Reason"),
      dataIndex: "reason",
      key: "reason",
      render: (val, record) => {
        // Check if this is a certificate issuance by Master Facilitator
        if (
          record.user_role === "master_facilitator" &&
          (record.creditType === "certification" ||
            (record.certificationCredits &&
              record.certificationCredits.count > 0))
        ) {
          return "Certificates issued";
        }
        return val || "-";
      },
    },
    {
      title: lang("Transaction Date & Time"),
      dataIndex: "transactionDateTime",
      key: "transactionDateTime",
      render: (val) => moment(val).format("lll"),
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  const fetchData = (pagination, filters) => {
    // Construct query params dynamically
    const queryParams = new URLSearchParams({
      page: pagination ? pagination.current : 1,
      limit: pagination ? pagination.pageSize : 10,
      search: debouncedSearchText || "",
    });

    // Only add filters if they exist
    if (filter?.startDate) queryParams.append("start_date", filter.startDate);
    if (filter?.endDate) queryParams.append("end_date", filter.endDate);
    if (userType) queryParams.append("userType", userType);
    if (status) queryParams.append("paymentStatus", status);

    try {
      setLoading(true);

      request({
        url: `${baseUrl}/list?${queryParams.toString()}`,
        method: "GET",
        onSuccess: (data) => {
          setLoading(false);
          console.log(data);
          // ShowToast(data.message, Severty.SUCCESS)
          setList(data.data.docs);
          setPagination((prev) => ({
            current: pagination.current,
            total: data.data.totalDocs,
          }));
        },
        onError: (error) => {
          console.log(error, "ON error here");
          setLoading(false);
          ShowToast(error?.response?.data?.message, Severty.ERROR);
        },
      });
    } catch (err) {
      console.log(err, "er catch ");
      setLoading(false);
      ShowToast("Internal server Error", Severty.ERROR);
    }
  };
  const statusChange = (recordId, newStatus) => {
    setLoading(true);
    request({
      url: `${baseUrl}/status-change/${recordId}?status=${newStatus}`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        console.log(error, "here chck transction");
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    fetchData(pagination, filters);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, filter, userType, status]);
  const downloadExcel = async () => {
    setExcelloading(true);
    try {
      const response = await fetch(
        `${apiPath.baseURL}/admin/transaction/downloadExcelFile`,
        {
          method: "GET",
          headers: {
            Accept: "text/csv",
          },
        }
      );

      if (!response.ok) {
        setExcelloading(false);
        throw new Error("Failed to fetch CSV file");
      }

      setExcelloading(false);

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "transactions.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      setExcelloading(false);
    }
  };

  return (
    <div className="tabled">
      <Row>
        <Col xs="24" md={24} lg={24} xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Transaction Management"
            extra={
              <>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={downloadExcel}
                  loading={excelLoading}
                >
                  Download Excel file
                </Button>
                <Search
                  size="large"
                  placeholder="Search by Transaction ID or User"
                  onChange={onSearch}
                  value={searchText}
                  onPressEnter={onSearch}
                />
                <Select
                  placeholder="Select User Role"
                  value={userType}
                  onChange={(value) => {
                    setUserType(value);
                    setPagination({ current: 1, pageSize: 10 });
                  }}
                  allowClear
                  style={{ marginRight: 8 }}
                >
                  <Option value="certified_practitioner">
                    Certified Practitioner
                  </Option>
                  <Option value="master_facilitator">Master Facilitator</Option>
                  <Option value="admin">Admin</Option>
                </Select>
                <Select
                  placeholder="Select Payment Status"
                  value={status}
                  onChange={(value) => {
                    setStatus(value);
                    setPagination({ current: 1, pageSize: 10 });
                  }}
                  allowClear
                  style={{ marginRight: 8 }}
                >
                  <Option value="pending">Pending</Option>
                  <Option value="approved">Approved</Option>
                  <Option value="rejected">Rejected</Option>
                </Select>
                <div className="role-wrap">
                  <DatePicker.RangePicker
                    disabledDate={(current) => {
                      return current && current > moment().endOf("day");
                    }}
                    placeholder={[lang("Start Date"), lang("End Date")]}
                    value={[
                      filter?.startDate ? moment(filter?.startDate) : undefined,
                      filter?.endDate ? moment(filter?.endDate) : undefined,
                    ]}
                    onChange={(value) => {
                      setPagination({ current: 1, pageSize: 10 });
                      if (value) {
                        setFilter((prev) => ({
                          ...prev,
                          startDate: moment(value[0]).format("YYYY-MM-DD"),
                          endDate: moment(value[1]).format("YYYY-MM-DD"),
                        }));
                      } else {
                        setFilter((prev) => ({
                          ...prev,
                          startDate: undefined,
                          endDate: undefined,
                        }));
                      }
                    }}
                  />
                </div>
                <Button
                  onClick={() => {
                    setFilter({
                      startDate: undefined,
                      endDate: undefined,
                    });
                    setUserType(null);
                    setStatus(null);
                    setSearchText("");
                    setPagination((prev) => {
                      return {
                        ...prev,
                        current: 1,
                        pageSize: 10,
                      };
                    });
                  }}
                  type="primary"
                  icon={<UndoOutlined />}
                >
                  {lang("Reset")}
                </Button>
                {/* <Button onClick={() => setVisible(true)}>Add Transaction</Button> */}
              </>
            }
          >
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={pagination}
                onChange={handleChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

// const AddFrom = ({ show, hide, data, refresh }) => {
//   const [form] = Form.useForm();
//   const { request } = useRequest()
//   const [loading, setLoading] = useState(false)
//   const [selectType, setSelectType] = useState("All");
//   const [selectUser, setSelectUser] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [userList, setUserList] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);

//   useEffect(() => {
//     if (!data) return
//     form.setFieldsValue({ ...data })
//   }, [data])
//   const onCreate = (values) => {
//     setLoading(true)
//     console.log(values, selectUser, "yuio")
//     const { title, message, type, Transactiontype } = values
//     const payload = {}
//     payload.title = title
//     payload.message = message
//     payload.type = selectType ? selectType : "All"
//     payload.selectUser = selectUser.length > 0 ? selectUser : []
//     payload.allUser = selectAll
//     payload.Transactiontype = Transactiontype
//     request({
//       url: `${data ? `/admin/Transaction/edit-Transaction/${data._id}` : `/admin/Transaction/add-Transaction`}`,
//       // url: '/admin/expact/add-expact',
//       method: `${data ? 'PUT' : 'POST'}`,
//       data: payload,
//       onSuccess: (data) => {
//         setLoading(false)
//         if (data.status) {
//           // ShowToast(data.message, Severty.SUCCESS)
//           // hide()
//           refresh()
//           hide()
//         } else {
//           ShowToast(data.message, Severty.ERROR)

//         }
//       },
//       onError: (error) => {
//         ShowToast(error.response.data.message, Severty.ERROR)
//         // console.log(error.response.data, "Error")
//         setLoading(false)
//       },
//     })
//   };

//   const handleSelectAll = (e) => {
//     const allUserIds = userList.map((user) => user._id);
//     setSelectUser(e.target.checked ? allUserIds : []);
//     setSelectAll(e.target.checked);
//   };
//   const handleTypeChange = (value) => {
//     const userType = value == "Driver" ? "Driver" : value
//     setSelectType(value);
//     getList(userType)
//     setSelectUser([]);
//     setLoading(false)
//   };
//   const handleUserChange = (value) => {
//     setSelectUser(value);
//     setSelectAll(value.length === userList.length);
//   };
//   const getList = (type) => {
//     setLoading(true);
//     request({
//       url: `/common/user-list/${type}`,
//       method: 'PUT',
//       onSuccess: (data) => {
//         // console.log(data.data.data)
//         setUserList(data.data.data)
//       },
//       onError: (error) => {
//         console.log(error)
//         ShowToast(error, Severty.ERROR)
//       }
//     })
//   };

//   return (
//     <Modal
//       visible={show}
//       title={`${data ? 'Edit' : 'Create'}`}
//       okText="Ok"
//       onCancel={hide}
//       okButtonProps={{
//         form: 'create',
//         htmlType: 'submit',
//         loading: loading,
//       }}
//     >
//       <Form id="create" form={form} onFinish={onCreate} layout="vertical">
//         <Form.Item
//           name="Transactiontype"
//           label="Transaction Type"
//           rules={[
//             { required: true, message: "Please select the Transaction Type!" }
//           ]}
//         >
//           <Select className="nottfy-add" placeholder="Select Type">
//             <Option value="Updates or changes to platform policies">Updates or changes to platform policies</Option>
//             <Option value="Promotional offers or discounts">Promotional offers or discounts</Option>
//             <Option value="Important alerts or reminders">Important alerts or reminders</Option>
//             <Option value="Feedback requests or surveys">Feedback requests or surveys</Option>
//             <Option value="Order status updates">Order status updates</Option>
//             <Option value="Payment reminders">Payment reminders</Option>
//             <Option value="Service maintenance Transactions">Service maintenance Transactions</Option>
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label="User Type"
//           rules={[
//             { required: true, message: "Please input the Type!" }
//           ]}
//         >
//           <Select className="nottfy-add" placeholder="Select Type" onChange={handleTypeChange}>
//             <Option value="All">ALL</Option>
//             <Option value="User">User</Option>
//             <Option value="Driver">Driver</Option>
//           </Select>
//         </Form.Item>

//         {selectType != "All" || selectType === null ?
//           <Form.Item
//             label={`Select ${selectType}`}
//             name="user"
//           // rules={[
//           //   { required: true, message: "Please input the  !" }
//           // ]}
//           >
//             <Checkbox checked={selectAll} onChange={handleSelectAll}>
//               Select All
//             </Checkbox>
//             {!selectAll ?
//               <Select
//                 placeholder={`Select ${selectType}`}
//                 mode="multiple"
//                 className="select-show-inn"

//                 value={selectUser}
//                 onChange={handleUserChange}
//                 filterOption={(input, option) => {
//                   console.log(option.props)
//                   const inputValue = input.toLowerCase();
//                   const optionLabel = option.props.children.toLowerCase();
//                   // const [code, phone] = optionLabel.split('-')
//                   // console.log(inputValue, optionLabel);

//                   return (optionLabel.includes(inputValue))
//                 }}
//               >
//                 {userList.length > 0 && userList.map((item) =>
//                 (
//                   <Option key={item._id} value={item._id}>
//                     {item.name}
//                   </Option>
//                 ))}
//               </Select> : null}
//           </Form.Item> : null}

//         <Form.Item
//           label="Title"
//           name="title"
//           rules={[
//             { required: true, message: "Please Enter the  title!" }
//           ]}
//         >
//           <Input />
//           {/* <Input type="textarea" /> */}
//         </Form.Item>
//         <Col span={24}>
//           <Form.Item
//             label="Message"
//             name="message"
//             className="textarea-inn"
//             rules={[
//               { required: true, message: "Please Enter the  message!" }
//             ]}
//           >
//             <TextArea rows={4} />
//             {/* <Input type="textarea" /> */}
//           </Form.Item>
//         </Col>

//       </Form>
//     </Modal>

//   )
// }

export default Transaction;
